import React, {useEffect, useState} from "react";
import {img} from "../../utils/ImageUtil";
import {url} from "../../utils/UrlsUtil";
import {isNotEmpty} from "../../utils/CommonUtil";
import "../../../style/common/components/list/_option_template_item.scss";
import {
    isBookWrapTemp,
    isBoxWrapTemp,
    isCardDesignTemp,
    isEGiftMsgTemp,
    isGiftMsgTemp,
    isMessageTemp,
    isQrSettingTemp, isTruxBoxWrapTemp,
    isWrapTemp
} from "../../const/TemplateConst";
import {Card, CardBody, CardImg, CardText, Image} from "react-bootstrap";
import {popConfirm} from "../../utils/MessageUtil.ts";
import {post} from "../../utils/FetchUtil.ts";

interface OptionTemplateItemProps{
    template_dto?: OrderInputTemplateDto | null | undefined;
    seal_type?: boolean;
    showDeleteButton?: boolean;
    showTitle?: boolean;
    disabled?: boolean;
    handleClick?: (dto:OrderInputTemplateDto) => void;
    handleDelete?: (template_id:number) => void;
}

export const OptionTemplateItem:React.FC<OptionTemplateItemProps> = ({
    template_dto = {},
    seal_type = false,
    showDeleteButton = false,
    showTitle = false,
    disabled = false,
    handleClick = () => {},
    handleDelete = () => {}
}) => {
    const [templateImagePath, setTemplateImagePath] = useState<string | null | undefined>("");
    const [addClassName, setAddClassName] = useState("");
    const onClickHandler = ( evt ) => {
        if(!disabled){
            handleClick(template_dto);
        }
        evt.stopPropagation();
    }
    const onClickDelete = ( evt ) => {
        if(!disabled){
            popConfirm(
                "テンプレートを削除します。よろしいですか？",
                () => {handleDelete(template_dto.template_id);}
            );
        }
        evt.stopPropagation();
    }
    useEffect(() => {
        if(seal_type){
            setTemplateImagePath(url("/images/qr/seal_white.png"));
        }else if(isQrSettingTemp(template_dto?.template_kbn)){
            if(template_dto?.qr_style_option_detail === 0 && template_dto?.transparent_option_detail === 0){
                setTemplateImagePath(url("/images/qr/png_white.png"));
            }else if(template_dto?.qr_style_option_detail === 0 && template_dto?.transparent_option_detail === 1){
                setTemplateImagePath(url("/images/qr/png_transparent.png"));
            }else if(template_dto?.qr_style_option_detail === 1 && template_dto?.transparent_option_detail === 0){
                setTemplateImagePath(url("/images/qr/seal_white.png"));
            }else if(template_dto?.qr_style_option_detail === 1 && template_dto?.transparent_option_detail === 1){
                setTemplateImagePath(url("/images/qr/seal_transparent.png"));
            }
        }else if(template_dto?.template_id != -1){
            if(!isNotEmpty(template_dto?.image_path)){
                setTemplateImagePath(url("/images/common/no_image.png"));
            }else{
                setTemplateImagePath(img(template_dto?.image_path));
            }
        }
        if(isMessageTemp(template_dto?.template_kbn)){
            setAddClassName(" online-mgs");
        }else if(isCardDesignTemp(template_dto?.template_kbn)){
            setAddClassName(" ondemand-card");
        }else{
            setAddClassName("");
        }
    });
    return (
        <div className={`option-template-item${addClassName}`} onClick={onClickHandler} disabled={disabled}>
            <div>
                {(showTitle || showDeleteButton) && <p className="template-item-title">
                    {showTitle && isGiftMsgTemp(template_dto?.template_kbn) && <>オンラインメッセージ</>}
                    {showTitle && isEGiftMsgTemp(template_dto?.template_kbn) && <>eGiftメッセージ</>}
                    {showTitle && isBoxWrapTemp(template_dto?.template_kbn) && <>Box用</>}
                    {showTitle && isTruxBoxWrapTemp(template_dto?.template_kbn) && <>TRUX Box用</>}
                    {showTitle && isBookWrapTemp(template_dto?.template_kbn) && <>Book用</>}
                    {showDeleteButton && <span className="btn-delete-template float-end" onClick={onClickDelete}></span>}
                </p>}
            </div>
            <div className="option-temp-body" disabled={disabled}>
                {isWrapTemp(template_dto?.template_kbn) &&
                    <div className="template-item-image" style={{
                        width: '100%',
                        border: 'solid .1rem #9F9F9F',
                        padding: '1rem 0',
                        minHeight: (isBookWrapTemp(template_dto?.template_kbn) ? '14rem' : '10rem'),
                        backgroundImage: (!template_dto?.inner_noshi && isNotEmpty(template_dto?.wrap_image_path)) ? `url(${img(template_dto?.wrap_image_path)})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        boxSizing: 'border-box'}}
                    >
                        {isNotEmpty(template_dto?.image_path) && <Image src={templateImagePath} fluid></Image>}
                        {template_dto?.inner_noshi && isNotEmpty(template_dto?.wrap_image_path) &&
                            <span className="top-wrap-paper"
                                  style={{
                                      backgroundImage: `url(${img(template_dto?.wrap_image_path)})`,
                                      backgroundSize: 'cover',
                                      backgroundPosition: 'center',
                                      backgroundRepeat: 'no-repeat',
                                      boxSizing: 'border-box'
                                  }}
                            ></span>}
                    </div>
                }
                {isEGiftMsgTemp(template_dto?.template_kbn) && <>
                    <div className="template-item-image" style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        padding: '1rem 0',
                        minHeight: '15rem',
                        backgroundImage: (isNotEmpty(template_dto?.image_path)) ? `url(${img(template_dto?.image_path)})` : 'none',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        boxSizing: 'border-box'}}
                    >
                        <p className={`egift-tmp-msg`}>
                            {isNotEmpty(template_dto?.input_message) && <span dangerouslySetInnerHTML={{ __html: template_dto?.input_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></span>}
                            <br/>{template_dto?.input_sender_name}
                        </p>
                    </div>
                </>}
                {isGiftMsgTemp(template_dto?.template_kbn) && <>
                    <div className="template-item-image">
                        <Image src={templateImagePath} fluid></Image>
                    </div>
                    <div className="template-item-messages">
                        <p>
                            {isNotEmpty(template_dto?.input_message) && <span dangerouslySetInnerHTML={{ __html: template_dto?.input_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></span>}
                            <br/>{template_dto?.input_sender_name}
                        </p>
                    </div>
                </>}
                {isQrSettingTemp(template_dto?.template_kbn) && <div className="template-item-image">
                    <Image src={templateImagePath} fluid></Image>
                </div>}
                {isCardDesignTemp(template_dto?.template_kbn) && <div className="template-item-image">
                    <Image src={templateImagePath} fluid={true} style={{borderRadius: '1rem', marginTop: '1rem'}}></Image>
                </div>}
            </div>
            <div>
                {isWrapTemp(template_dto?.template_kbn) && <p className="template-item-name">{template_dto?.template_name}</p>}
            </div>
        </div>
    );
};
export default OptionTemplateItem;